<template>
  <v-layout>

    <v-flex xs12 sm5 md3 class="mb-2">
      <v-date-picker
        scrollable
        full-width
        :locale="$i18n.locale"
        first-day-of-week="1"
        v-model="selectedDate"
        :picker-date.sync="selectedMonth"
        event-color="accent"
        color="primary"
        header-color="white"
        :events="eventiCalendario"/>
      <v-btn
        v-if="!$store.getters.isAbbonamentoExpired"
        class="mx-0"
        block
        color="accent"
        @click="showCreateDialog">
        <v-icon class="mr-2">add</v-icon>
        {{ $t('prenotazioni.azioni.nuovo') }}
      </v-btn>
    </v-flex>

    <v-flex class="scrollable-flex scroll-y" xs12 sm7 md9>
      <prenotazioni-list
        ref="prenotazioniList"
        :loading="loading"
        :prenotazioni="prenotazioniDataSelezionata"
        @change="fetchPrenotazioni"/>
    </v-flex>

  </v-layout>
</template>
<script>
import PrenotazioniList from '@/components/PrenotazioniList'

export default {
    name: 'PrenotazioniCalendar',
    components: { PrenotazioniList },
    data () {
        return {
            prenotazioni: [],
            selectedDate: this.$utils.date.getSqlToday(), //  Giorno selezionato
            selectedMonth: '', //  Mese selezionato
            loading: true
        }
    },
    computed: {
        eventiCalendario () {
            //  Restituisce un'array per mostrare i 'pallini' nel calendario dove sono presenti eventi
            return this.prenotazioni.map(val => val.data_controllo)
        },
        prenotazioniDataSelezionata () {
            //  Restituisce tutte le prenotazioni del giorno selezionato
            let _this = this
            return this.prenotazioni.filter((val) => val.data_controllo === _this.selectedDate)
        }
    },
    watch: {
        selectedMonth () {
            this.fetchPrenotazioni() // Richiede un update dei dati quando viene cambiato l'anno selezionato
        }
    },
    methods: {
        showCreateDialog () {
            this.$refs.prenotazioniList.showCreateDialog(this.selectedDate)
        },
        fetchPrenotazioni () {
            this.loading = true
            let from = new Date(this.selectedMonth)
            let to = new Date(from.getFullYear(), from.getMonth() + 1, 0)

            this.$api.prenotazioni.get({
                from: this.$utils.date.toSql(from),
                to: this.$utils.date.toSql(to)
            }).then(response => {
                this.loading = false
                this.prenotazioni = response.data.items
            }).catch(e => {
                this.$snackbar.showServerError(e)
                this.loading = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
  .scrollable-flex {
    height: 100%;
  }
</style>
